import { shape, string, arrayOf, node, oneOfType, any, number } from 'prop-types';

export const selectValueConfig = oneOfType([string, number, arrayOf(any), shape({})]);

export const selectOptionConfig = shape({
  complexLabel: node.isRequired,
  label: node,
  value: selectValueConfig.isRequired,
});
